// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610151215/js/" + chunkId + "." + {"44":"f21b8e40","225":"ea65927d","481":"60600b4e","486":"4c739869","770":"b9159b1c"}[chunkId] + ".0.5310181191269827.chunk.js";
};